import React from 'react' // eslint-disable-line import/no-extraneous-dependencies
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet' // eslint-disable-line import/no-extraneous-dependencies

// custom components
import Banner from './Banner'

// images
import sacramentsBg from '../assets/images/alter.jpg'
import aboutBg from '../assets/images/closeup-inside-side-church.jpg'
import eventsBg from '../assets/images/pews.jpg'
import newsletterBg from '../assets/images/bible.jpg'
import pastoralCouncilBg from '../assets/images/alter-ceiling.jpg'
import donationsBg from '../assets/images/offering-candles.jpg'

const Sacraments = props => {
  const {
    title,
    metaDescription,
    bannerTitle,
    bannerText,
    boxOneHeading,
    boxOneDescription,
    boxOneLink,
    boxTwoHeading,
    boxTwoDescription,
    boxTwoLink,
    boxThreeHeading,
    boxThreeDescription,
    boxThreeLink,
    boxFourHeading,
    boxFourDescription,
    boxFourLink,
    boxFiveHeading,
    boxFiveDescription,
    boxFiveLink,
    boxSixHeading,
    boxSixDescription,
    boxSixLink,
  } = props.data.contentfulSacraments

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | ${props.data.site.siteMetadata.title}`}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div id="main">
        <section id="one" className="tiles">
          <article style={{ backgroundImage: `url(${sacramentsBg})` }}>
            <header className="major">
              <h3>{boxOneHeading}</h3>
              {boxOneDescription !== null || boxOneDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxOneDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxOneLink}`}
              className="link primary"
              title={boxOneHeading}
            />
          </article>
          <article style={{ backgroundImage: `url(${aboutBg})` }}>
            <header className="major">
              <h3>{boxTwoHeading}</h3>
              {boxTwoDescription !== null || boxTwoDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxTwoDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxTwoLink}`}
              className="link primary"
              title={boxTwoHeading}
            />
          </article>
          <article style={{ backgroundImage: `url(${eventsBg})` }}>
            <header className="major">
              <h3>{boxThreeHeading}</h3>
              {boxThreeDescription !== null ||
              boxThreeDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxThreeDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxThreeLink}`}
              className="link primary"
              title={boxThreeHeading}
            />
          </article>
          <article style={{ backgroundImage: `url(${newsletterBg})` }}>
            <header className="major">
              <h3>{boxFourHeading}</h3>
              {boxFourDescription !== null ||
              boxFourDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxFourDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxFourLink}`}
              className="link primary"
              title={boxFourHeading}
            />
          </article>
          <article style={{ backgroundImage: `url(${pastoralCouncilBg})` }}>
            <header className="major">
              <h3>{boxFiveHeading}</h3>
              {boxFiveDescription !== null ||
              boxFiveDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxFiveDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxFiveLink}`}
              className="link primary"
              title={boxFiveHeading}
            />
          </article>
          <article style={{ backgroundImage: `url(${donationsBg})` }}>
            <header className="major">
              <h3>{boxSixHeading}</h3>
              {boxSixDescription !== null || boxSixDescription !== undefined ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: boxSixDescription.childMarkdownRemark.html,
                  }}
                />
              ) : (
                undefined
              )}
            </header>
            <Link
              to={`/${boxSixLink}`}
              className="link primary"
              title={boxSixHeading}
            />
          </article>
        </section>
      </div>
    </React.Fragment>
  )
}

Sacraments.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Sacraments



// WEBPACK FOOTER //
// ./src/components/Sacraments.js